interface IconUpArrowProps {
  color?: string;
}

export default function IconUpArrow(props: IconUpArrowProps) {
  return (<svg xmlns="http://www.w3.org/2000/svg" className="w-full h-full" viewBox="0 0 13 18" fill="none">
    <path
      d="M5.92965 0.21042C6.25923 -0.0701483 6.74014 -0.070132 7.06974 0.21042L12.6814 4.98746C13.3159 5.52793 12.939 6.5787 12.1108 6.5787H9.86074C9.73828 6.5787 9.639 6.67953 9.639 6.80392V14.7252C9.639 17.5261 5.08873 18.0854 1.68868 17.9901C1.42667 17.9828 1.37553 17.4566 1.60856 17.3347C3.20719 16.5007 3.6591 15.0091 3.65921 14.2017V6.80392C3.65921 6.67953 3.55993 6.5787 3.43747 6.5787H0.888557C0.0602363 6.5787 -0.315781 5.52787 0.319052 4.98746L5.92965 0.21042Z"
      fill={props.color}
    />
  </svg>);
}